export const vehicles = {
  buses: [
    {
      id: 'bus-2050c',
      model: 'MODEL 2050-C',
      name: '20.50 Series - 21 Seater',
      seating: '19+1+1 Seater',
      features: [
        'BS6 Engine with GPS Tracking',
        'CCTV Camera + Fire Extinguisher',
        'Comfortable Pushback Seats',
        'Finance & Insurance Available',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-2075d',
      model: 'MODEL 2075-D',
      name: '20.75 Series - 26 Seater',
      seating: '24+1+1 Seater',
      features: [
        'Wide Body, More Leg Space',
        'High Roof for Comfort',
        'BS6 Power Engine',
        'Best for School/Staff',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-2065e',
      model: 'MODEL 2065-E',
      name: '20.65 Series - 36 Seater',
      seating: '34+1+1 Seater',
    
      features: [
        'Mid Size Bus, Low Maintenance',
        'Best Mileage in Segment',
        'School + Tourist Permit',
        'Strong Build Quality',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-2075g',
      model: 'MODEL 2075-G',
      name: '20.75 Series - 42 Seater',
      seating: '40+1+1 Seater',
      imageUrl: 'https://bansalmotors.com/assets/images/2075-g.jpg',
      features: [
        'Standard School Bus',
        'Most Selling Model',
        'BS6 + ABS + GPS',
        'Easy EMI Options',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-2075h',
      model: 'MODEL 2075-H',
      name: '20.75 Series - 48 Seater',
      seating: '46+1+1 Seater',
      imageUrl: 'https://bansalmotors.com/assets/images/2075-h.jpg',
      features: [
        'Large Capacity Bus',
        'Best for Long Route',
        'Luggage Space Available',
        'AC/Non-AC Option',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-2090k',
      model: 'MODEL 2090-K',
      name: '20.90 Series - 52 Seater',
      seating: '50+1+1 Seater',
      imageUrl: 'https://bansalmotors.com/assets/images/2090-k.jpg',
      features: [
        'High Power Engine',
        'Best for Tourist/Contract',
        'Comfortable 3x2 Seats',
        'Pan India Permit Ready',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-2090l',
      model: 'MODEL 2090-L',
      name: '20.90 Series - 58 Seater',
      seating: '56+1+1 Seater',
      imageUrl: 'https://bansalmotors.com/assets/images/2090-l.jpg',
      features: [
        'Maximum Capacity',
        'Heavy Duty Chassis',
        'Best for Staff Transport',
        'Low Running Cost',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-3009',
      model: 'MODEL 3009',
      name: '30.09 Series - 52 Seater',
      seating: '50+1+1 Seater',
      imageUrl: 'https://bansalmotors.com/assets/images/3009.jpg',
      features: [
        'Premium Bus Segment',
        'Air Brake + Power Steering',
        'Tourist Bus Body',
        'High Resale Value',
      ],
      category: 'School & Tourist Buses',
    },
    {
      id: 'bus-3010',
      model: 'MODEL 3010',
      name: '30.10 Series - 62 Seater',
      seating: '60+1+1 Seater',
      imageUrl: 'https://bansalmotors.com/assets/images/3010.jpg',
      features: [
        'Biggest Capacity Bus',
        'Best for Long Distance',
        'Luxury Pushback Seats',
        'AC/Non-AC Both Options',
      ],
      category: 'School & Tourist Buses',
    },
  ],
  lcv: [
    {
      id: 'lcv-2049',
      model: 'MODEL 2049',
      name: 'Smaller Commercial Vehicle',
      features: [
        'Best for First Time Users',
        'Compact & Easy to Drive',
        'Low Maintenance Cost',
        'High Fuel Efficiency',
        'GVW-4995',
      ],
      category: 'Light Commercial Vehicles (LCV)',
    },
    {
      id: 'lcv-2059xp',
      model: 'MODEL 2059XP',
      name: 'Diesel / CNG Variant',
      features: [
        'Diesel & CNG Fuel Options',
        '1-2 Ton Payload Capacity',
        'Best for Goods Transport',
        'Strong ROI for Business',
        'GVW-7490',
      ],
      category: 'Light Commercial Vehicles (LCV)',
    },
    {
      id: 'lcv-2095',
      model: 'MODEL 2095',
      name: 'LCV Series',
      features: [
        'Reliable Commercial Vehicle',
        'Good for Transport Business',
        'Low Running Cost',
        'Finance Options Available',
        'GVW-11449',
      ],
      category: 'Light Commercial Vehicles (LCV)',
    },
    {
      id: 'lcv-2080',
      model: 'MODEL 2080',
      name: 'Premium LCV - On Order',
      features: [
        'Only on Confirmed Order',
        'Purchased by Rare Customers',
        'Customized for Specific Needs',
        'GVW-9250',
      ],
      category: 'Light Commercial Vehicles (LCV)',
    },
    {
      id: 'lcv-2110',
      model: 'MODEL 2110',
      name: '11.10 Series LCV',
      features: [
        'Higher Load Capacity',
        'Strong Build for Rough Roads',
        'Most Selling Model',
        'Easy Finance Available',
        'GVW-11990',
      ],
      category: 'Light Commercial Vehicles (LCV)',
    },
  ],
  heavyDuty: [
    {
      id: 'hd-6055',
      model: 'MODEL 6055',
      name: '60.55 Series - Tractor Trailer',
      features: [
        'Heavy Duty 6X4 Drive',
        'Best for Container/ODC',
        'High Torque BS6 Engine',
        'Pan India Permit Support',
        'GVW-55000',
      ],
      category: 'Heavy Duty (HD) Trucks',
    },
    {
      id: 'hd-6048',
      model: 'MODEL 6048',
      name: '60.48 Series - Tractor Trailer',
      features: [
        'Best Mileage in Segment',
        'Ideal for 40ft Container',
        'BS6 Power Engine',
        'Low Maintenance Cost',
        'GVW-47500',
      ],
      category: 'Heavy Duty (HD) Trucks',
    },
    {
      id: 'hd-6028',
      model: 'MODEL 6028',
      name: '60.28 Series - Tractor Trailer',
      features: [
        'Best for City Container',
        'Short Wheelbase Advantage',
        'BS6 High Torque Engine',
        'Easy Turning Radius',
        'GVW-28000',
      ],
      category: 'Heavy Duty (HD) Trucks',
    },
    {
      id: 'hd-6035',
      model: 'MODEL 6035',
      name: '60.35 Series - Tractor Trailer',
      features: [
        'Power + Mileage Balance',
        'Best for Bulk Transport',
        'BS6 Engine with High Torque',
        'Finance & Permit Support',
        'GVW-35000',
      ],
      category: 'Heavy Duty (HD) Trucks',
    },
    {
      id: 'hd-6042',
      model: 'MODEL 6042',
      name: '60.42 Series - Tractor Trailer',
      features: [
        'High Power Engine',
        'Best for Long Haul Transport',
        'BS6 Engine with High Torque',
        'Finance & Permit Support',
        'GVW-42000',
      ],
      category: 'Heavy Duty (HD) Trucks',
    },
  ],
};
